document.addEventListener("DOMContentLoaded", () => {
  const preview = document.querySelector("#preview-image");

  const carcasaInput = document.querySelector("#property-carcasa");
  const botonesInput = document.querySelector("#property-botones");
  const stickerInput = document.querySelector("#property-sticker");

  const selectedImages = {
    carcasa: '',
    botones: '',
    sticker: ''
  };

  // Cuando el usuario hace click en una opción
  document.querySelectorAll(".option").forEach(btn => {
    btn.addEventListener("click", () => {
      const type = btn.dataset.type;
      const value = btn.dataset.value;
      const image = btn.dataset.image;

      // Guardar el valor en input hidden
      if(type === "carcasa") carcasaInput.value = value;
      if(type === "botones") botonesInput.value = value;
      if(type === "sticker") stickerInput.value = value;

      // Guardar la imagen seleccionada
      selectedImages[type] = image;

      // Actualizar preview combinando imágenes
      updatePreview();
    });
  });

  function updatePreview() {
    // Aquí combinamos imágenes como capa (carcasa + botones + sticker)
    // Para simplificar, mostramos solo la última seleccionada
    // Más adelante podemos usar canvas para combinar
    const imageToShow = selectedImages.sticker || selectedImages.botones || selectedImages.carcasa || "{{ 'default.png' | asset_url }}";
    preview.src = imageToShow;
  }
});
